import {FC, useState} from 'react'
import {Modal} from 'react-bootstrap'
import {useIntl} from 'react-intl'
import {axiosUserCarDelete, axiosUserInfo} from '../../../../setup/axios/AxiosUser'
import {LoaderForm} from '../../forms/billing-form/components/BillingLoaderForm'

import './CarDeleteModal.css'

type Props = {
  modalShow: any
  setModalShow: any
  plateNumber: any
  setCarsData: any
  setParentErrorMessage: any
}

const CarDeleteModal: FC<Props> = ({
  modalShow,
  setModalShow,
  plateNumber,
  setCarsData,
  setParentErrorMessage,
}) => {
  const [errorMessage, setErrorMessage] = useState('')
  const [loader, setLoader] = useState(false)

  const intl = useIntl()

  const carDeleteFunc = () => {
    setLoader(true)
    axiosUserCarDelete(plateNumber).then((resp) => {
      if (resp.code === 200) {
        axiosUserInfo().then((resp) => {
          setLoader(false)
          setModalShow(false)
          if (resp.code === 200) {
            if (resp.message.cars.length > 0) {
              setCarsData(resp.message.cars)
            }
            if (resp.message.cars.length === 0) {
              setCarsData([])
            }
          }
          if (resp.code !== 200) {
            setParentErrorMessage('error')
          }
        })
      }

      if (resp.code !== 200) {
        setLoader(false)
        setErrorMessage('error')
      }
    })
  }

  return (
    <div>
      <Modal
        show={modalShow}
        onHide={() => {
          setModalShow(false)
        }}
        aria-labelledby='contained-modal-title-vcenter'
        centered
      >
        <Modal.Body>
          {!loader && (
            <div className='d-flex flex-column h-150px justify-content-center'>
              <div className='w-100 justify-content-center fs-1 fw-bolder d-flex'>
                {intl.formatMessage({id: 'ABONEMENT.DELETE.ARE-YOU-SURE'})}
              </div>
              {errorMessage === 'something went wrong' && (
                <div>{intl.formatMessage({id: 'LOGIN.ERROR.SOMETHING-WENT-WRONG'})}</div>
              )}
              <div className='d-flex flex-row'>
                <button
                  className='h-40px w-50 justify-content-center btn d-flex align-items-center mt-5 me-2'
                  style={{
                    borderRadius: '14px',
                    background: '#127FEE',
                    color: 'white',
                    backgroundColor: 'rgb(18,127,238)',
                  }}
                  onClick={() => carDeleteFunc()}
                >
                  {intl.formatMessage({id: 'ABONEMENT.DELETE.YES'})}
                </button>
                <button
                  className='h-40px w-50 justify-content-center btn d-flex align-items-center mt-5 ms-2'
                  style={{
                    borderRadius: '14px',
                    background: '#127FEE',
                    color: 'white',
                    backgroundColor: 'rgb(18,127,238)',
                  }}
                  onClick={() => setModalShow(false)}
                >
                  {intl.formatMessage({id: 'ABONEMENT.DELETE.NO'})}
                </button>
              </div>
            </div>
          )}
          {loader && (
            <div className='d-flex flex-column h-150px'>
              <LoaderForm />
            </div>
          )}
        </Modal.Body>
      </Modal>
    </div>
  )
}

export {CarDeleteModal}
